import React,{ useEffect, useState, useRef, useCallback } from "react"
import { useProfileForm, ProfileSchemaType, ProfileFormHookReturn } from "../../../utils/hooks/useProfileForm"
import {
  Container, Modal, useMediaQuery, IconButton, Typography, Tooltip,
  Stack, List, ListItem, Card, ListItemButton, Collapse, Button, Grid, Box, TextField, ThemeProvider, InputAdornment,
  Dialog, DialogTitle, DialogContent, DialogActions,
} from "@mui/material"
import { theme } from '../../../config/Dashboardtheme'
import { emptyProfileSchema, fromProfileFields } from "@meprism/shared/src/schemas/EmployeeProfileForm"
import { useAppDispatch } from '../../../redux/storeExports'
import closeicon from '@meprism/shared/src/assets/icons/successclose.png'
import { ExpandLess, ExpandMore, Warning as WarningIcon, HelpOutlineOutlined } from '@mui/icons-material';
import {
  Controller,
  FieldValues,
  UseFieldArrayReturn,
  UseFormWatch,
} from 'react-hook-form'
import { useLocation } from 'react-router-dom'
import PageLayout from "../../layouts/ExecUserProfileDashboardPageLayout"
import { UpdateExecutiveUserBirthdate, FetchExecutiveEmployeeProfile } from "@meprism/shared/src/redux/profile/ProfileSlice"
import { DatePicker ,LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import {Toast} from '../../toast/toast'
import deleteIcon from '@meprism/shared/src/assets/icons/trash.svg'
import editIcon from '@meprism/shared/src/assets/icons/Pencil.svg'
import CircularProgress from '@mui/material/CircularProgress';
import { isAddressIncomplete } from '../../../utils/helpers'
import { ReactComponent as CalendarIcon } from '../../../assets/images/calendar.svg'
import NumberEmptyIcon from '@meprism/shared/src/assets/icons/number-empty.svg'
import EmailEmptyIcon from '@meprism/shared/src/assets/icons/email-empty.svg'
import { PhoneNumberInput } from "./inputs/PhoneNumberInput"
import {ReactComponent as ShieldIcon} from '../../../assets/images/shield-tick.svg'
import {ReactComponent as CopyIcon} from '../../../assets/images/copyicon.svg'
import { isValidPhoneNumber } from 'libphonenumber-js'

interface ProfileDashboardProps {
  muid: string
  isModalOpen: boolean
  setIsModalOpen: (open: boolean) => void
}

interface SidebarProps {
  activeSection: number
  sections: string[]
  onSectionChange: (sectionIndex: number) => void
}

interface PersonalInfoSectionProps {
  firstNameArray: UseFieldArrayReturn<ProfileSchemaType, 'firstName', 'id'>
  middleNameArray: UseFieldArrayReturn<ProfileSchemaType, 'middleName', 'id'>
  lastNameArray: UseFieldArrayReturn<ProfileSchemaType, 'lastName', 'id'>
  otherFirstNameArray: UseFieldArrayReturn<
    ProfileSchemaType,
    'otherFirstName',
    'id'
  >
  otherMaidenNameArray: UseFieldArrayReturn<
    ProfileSchemaType,
    'otherMaidenName',
    'id'
  >
  register: ProfileFormHookReturn['register']
  trigger: ProfileFormHookReturn['trigger']
  errors: ProfileFormHookReturn['formState']['errors']
  control?: ProfileFormHookReturn['control']
  setValue: ProfileFormHookReturn['setValue']
  watch: UseFormWatch<ProfileSchemaType>
  muid: string
  profile: ProfileSchemaType
  setProfile: React.Dispatch<React.SetStateAction<ProfileSchemaType | null>>
  setError: ProfileFormHookReturn['setError']
}

interface LocationsAddressesSectionProps {
  addressArray: UseFieldArrayReturn<ProfileSchemaType, 'address', 'id'>
  register: ProfileFormHookReturn['register']
  errors: ProfileFormHookReturn['formState']['errors']
  control?: ProfileFormHookReturn['control']
  addressValues: ProfileSchemaType['address']
  trigger: ProfileFormHookReturn['trigger']
}

interface ContactInfoSectionProps {
  emailArray: UseFieldArrayReturn<ProfileSchemaType, 'email', 'id'>
  phoneNumberArray: UseFieldArrayReturn<ProfileSchemaType, 'phoneNumber', 'id'>
    phoneNumberArrayValue: {value: string ;}[]
  emailArrayValue: { value: string; }[]
  register: ProfileFormHookReturn['register']
  trigger: ProfileFormHookReturn['trigger']
  errors: ProfileFormHookReturn['formState']['errors']
  control?: ProfileFormHookReturn['control']
  setValue: ProfileFormHookReturn['setValue']
}

type AddressType = ProfileSchemaType['address'][number]

const styles = {
  inputContainer: {
    width: '100%',
    marginLeft: '0px',
  },
  header: {
    color: '#3A155A',
    mb: 5,
    fontSize: '20px',
    lineHeight: '27px',
    fontFamily: 'InterMedium',
    fontWeight: 500,
  },
  header2: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontSize: '16px',
    lineHeight: '27px',
    fontFamily: 'InterMedium',
    fontWeight: 500,
    width: '100%',
    color: '#3A155A',
    mb: 4,
  },
  fullWidth: {
    width: '100%',
  },
  required: {
    '&:after': {
      content: '"*"',
      color: '#9135E0',
    },
  },
  label: {
    color: '#6B7280',
    fontFamily: 'InterRegular',
    fontWeight: 400,
    fontSize: '14px',
    mb: 2,
  },
  textField: {
    background: '#EFEDFDB2',
  },

  mb1: {
    marginBlock: '1rem',
  },
  borderBlack: {
    borderColor: '#a5a1a1',
  },
  fieldlabel:{
    mb: 1
  },
  paragraph: {
    color: '#6B7280',
    mb: 5,
    fontFamily: 'InterRegular',
    fontWeight: 400,

  },
  button: {
    borderRadius: '10px',
    width: '100%',
    maxWidth: '163px',
    height: '50px',
    backgroundColor: '#9135E0 !important',
    color: '#FFFFFF',
    fontFamily: 'InterRegular',
    fontWeight: 500,
    fontSize: '14px !important',
    lineHeight: '150%',
    letterSpacing: '2%',
    textAlign: 'center',
    '&:hover': {
      backgroundColor: '#9135E0',
    },
  },
  addressTableHeader:{
    fontFamily: 'InterMedium',
    fontWeight: 500,
    fontSize: '14px',
    color: '#3A155A',
    lineHeight: '20px',
    py: 2,
    pl: 2,
  },
  addressTableCell:{
    fontFamily: 'InterRegular',
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '20px',
    color: '#6B7280',
    wordBreak: 'break-word', 
    py: 4,
    pl: 2,
  }
} as const

  const Sidebar: React.FC<SidebarProps> = ({activeSection, sections, onSectionChange}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        width: '100%',
        gap: 5,
        height: 'auto'
      }}>
      {sections.map((section, index) =>
        <Box
          sx={{
            display: "flex",
            height: '40px',
          }}
          key={index}

          onClick={() => {
            onSectionChange(index)
          }}>
          <Box
            sx={{
              color: index === activeSection ? '#9135E0' : '#6B7280',
              fontFamily: index === activeSection ? 'InterMedium' : 'InterRegular',
              cursor: 'pointer',
              fontWeight: index === activeSection ? 500 : 400,
              fontSize: '18px',
              borderBottom: index === activeSection ? '2px solid #9135E0' : 'none',
            }}>
            {section}
          </Box>
        </Box>)}
    </Box>
  )
}

const PersonalInfoSection: React.FC<PersonalInfoSectionProps> = ({
  register,
  trigger,
  errors,
  control,
  firstNameArray,
  lastNameArray,
  middleNameArray,
  otherFirstNameArray,
  otherMaidenNameArray,
  setValue,
  watch,
  muid,
  profile,
  setProfile,
  setError
}) => {
  const linkedInValue = watch('linkedIn');
  const dispatch = useAppDispatch();

  const handleLinkedInChange = async (newValue: string) => {
    setValue('linkedIn', newValue);
    await trigger('linkedIn');
  };

  // --- DOB Update Logic ---
  const [isDobModalOpen, setIsDobModalOpen] = useState(false);
  const [newDob, setNewDob] = useState<Date | null>(null);
  const [originalDob, setOriginalDob] = useState<Date | null>(null);
  const [edit, setEdit] = useState(false)
  const [copied, setCopied] = useState(false)

  const dobCounter = profile?.metadata?.dob_counter ?? 0;
  const isDobDisabled = dobCounter >= 1;

  // Initialize originalDob state from profile data
  useEffect(() => {
    if (profile?.birthdate && !originalDob) {
      const birthdateValue = new Date(profile.birthdate);
      if (!isNaN(birthdateValue.getTime())) {
        setOriginalDob(birthdateValue);
      }
    } else if (profile === null) {
      // Clear all DOB states when profile is cleared
      setIsDobModalOpen(false);
      setNewDob(null);
      setOriginalDob(null);
    }
  }, [profile?.birthdate, originalDob, profile]);

  const updateDobValue = async (dateToUpdate: Date, shouldCloseModal = false) => {
    try {
      // Format date to ISO string format (YYYY-MM-DD)
      const formattedDate = dateToUpdate.toISOString().split('T')[0];

      // Update the birthdate
      const result = await dispatch(UpdateExecutiveUserBirthdate({
        birthdate: formattedDate,
        muid: muid
      }));

      // Check if update was successful
      if (!result.type.endsWith('/fulfilled')) {
        throw new Error('Update failed');
      }

      // Fetch the latest profile to get the updated dob_counter
      const response = await dispatch(FetchExecutiveEmployeeProfile(muid));

      if (response.type.endsWith('/fulfilled')) {
        const fetchedProfile = response.payload;

        setOriginalDob(dateToUpdate);
        setValue('birthdate', dateToUpdate, { shouldDirty: false });

        setProfile((prevProfile: any) => ({
          ...prevProfile,
          metadata: {
            ...prevProfile?.metadata,
            dob_counter: fetchedProfile?.metadata?.dob_counter
          }
        }));
      }

      if (shouldCloseModal) {
        setIsDobModalOpen(false);
        setNewDob(null);
      }
    } catch (error) {
      console.error("Failed to update birthdate:", error);
      Toast.show({ type: 'error', text1: 'Failed to update birthdate. Please try again.' });

      if (originalDob) {
        setValue('birthdate', originalDob, { shouldDirty: true });
      }

      if (shouldCloseModal) {
        setIsDobModalOpen(false);
        setNewDob(null);
      }
    }
  };

  // Modal confirmation handler - calls unified function with modal cleanup
  const handleDobUpdateAgree = async () => {
    if (!newDob) {
      console.error('No new DOB value provided');
      Toast.show({ type: 'error', text1: 'Invalid date value. Please try again.' });
      setIsDobModalOpen(false);
      return;
    }
    await updateDobValue(newDob, true);
  };

  const handleDobUpdateDisagree = useCallback(() => {
    try {
      // Safely revert to original date if available and valid
      if (originalDob && !isNaN(originalDob.getTime())) {
        setValue('birthdate', originalDob, { shouldDirty: true });
      }
    } catch (error) {
      console.error('Error reverting DOB on disagree:', error);
      // Don't show user error for this as it's a cancel action
    } finally {
      // Always close modal and clear temporary state
      setIsDobModalOpen(false);
      setNewDob(null);
    }
  }, [originalDob, setValue]);

  // Direct update handler - calls unified function without modal cleanup
  const handleDirectDobUpdate = async (newDate: Date) => {
    await updateDobValue(newDate, false);
  };

  const handleCopy = async () => {
    await navigator.clipboard.writeText(muid)
    setCopied(true)
    setTimeout(() => setCopied(false), 1000)
  }

  const isMobile = useMediaQuery('(max-width:600px)')

  const currentMiddleName = middleNameArray?.fields?.[0]?.value || '';

  return (
    <>
      <ThemeProvider theme={theme}>
        <Stack direction={{ xs: 'column', md: 'column' }}>

          {/* Basic info card */}
          <Card
            sx={{
              py: !isMobile ? 5 : 2,
              px: isMobile ? 0 : 5,
              mt: !isMobile ? 5 : 0,
              borderRadius: '15px',
              overflow: 'auto',
              boxShadow: isMobile ? 'none' : '0px 6px 10px 4px #0000000A',
            }}
          >
            <Box sx={{width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start'}}>            
              <Box sx={{display: 'flex', gap: 3, alignItems: 'flex-start'}}>
              {!isMobile && (
              <Typography sx={styles.header}>
                Basic Info
              </Typography>
              )}
              <img
                onClick={() => {
                    setEdit(prev => !prev)
                }}
                src={editIcon}
                alt="Description of the image"
                style={{
                    cursor: 'pointer',
                    maxWidth: '40px',
                    maxHeight: '40px',
                    marginRight: isMobile ? 0 : '10px',
                }}
              />
              </Box>
              <Box sx={{display: 'flex', gap: 2, alignItems: 'center'}}>
                <Typography 
                  sx={{
                    fontFamily: 'InterRegular', 
                    fontWeight: 400, 
                    mb: 1, 
                    fontSize: '10px', 
                    color: '#8C8C8C'
                  }}>
                  MUID: {muid}
                </Typography>
                <Tooltip
                title="Copied!"
                open={copied}
                disableHoverListener
                placement="top"
                componentsProps={{
                  tooltip: {
                    sx: {
                      fontFamily: 'InterRegular',
                      fontSize: '10px',
                      lineHeight: '16px',
                      fontWeight: 500,
                      color: '#ffffff',
                    },
                  },
                }}
                >
                <Box 
                  sx={{
                    cursor: 'pointer',
                  }}
                  onClick={handleCopy}
                  >
                <CopyIcon/>
                </Box>
                </Tooltip>
              </Box>
            </Box>
            <Stack width={{md: '92%', lg: '90.5%'}} spacing={3} display={'flex'} flexDirection={'column'}>
              <Typography sx={styles.paragraph} >
                We use your information to look for additional records of yours.
                Additional information like alternative names helps us find more of
                your data.
              </Typography>

              <Stack spacing={3} display={'flex'} flexDirection={['column', 'row']}>
                <Grid
                  container
                  spacing={2}
                  alignItems="flex-start"
                  justifyContent={'space-between'}
              sx={{width: '100%'}}>

                {/* First name */}
                  {firstNameArray.fields[0] && (
                <Grid item md={4} sm={12} sx={{width: '100%'}}>
                      <Typography
                        sx={{ ...styles.label, ...styles.required }}>
                        First Name
                      </Typography>
                      <TextField
                        fullWidth
                        required
                        disabled={edit && !firstNameArray.fields[0]?.value ? false : true}
                        defaultValue={''}
                        placeholder="Enter your first name" 
                        error={!!errors?.firstName?.[0]?.value}
                        helperText={errors?.firstName?.[0]?.value?.message}
                    InputLabelProps={{shrink: true}}
                        {...register(`firstName.${0}.value` as const)}
                        sx={{
                          backgroundColor: '#FFF',
                          border: 'none',
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '10px',
                            height: '50px',
                            backgroundColor: '#FFF',
                            border: 'none',
                            '& fieldset': {
                              border: edit && !firstNameArray.fields[0]?.value ? '1.5px solid #9135E0 !important' : '1.5px solid #E2E8F0 !important'
                            },
                          },
                          '& .MuiInputBase-input': {
                            color: '#3A155A',
                            paddingLeft: '20px',
                            fontFamily: 'InterRegular',
                            fontWeight: 400,
                            fontSize: '14px',
                            lineHeight: '140%',
                          },
                          '& .MuiInputBase-input::placeholder': {
                              opacity: 1,
                              fontSize: '14px',
                              fontWeight: 400,
                              fontFamily: 'InterRegular',
                          },
                          '& .Mui-disabled .MuiInputBase-input::placeholder': {
                              '-webkit-text-fill-color': '#A0AEC0',
                          }
                        }}
                        onChange={(e) => {
                      firstNameArray.update(0, {value: e.target.value})
                        }}
                      />
                    </Grid>
                  )}

                  {/* Middle name */}
                  {middleNameArray.fields[0] && (
                <Grid item md={4} sm={12} sx={{width: '100%'}}>
                      <Typography
                        sx={{ ...styles.label, ...styles.required }}>
                        Middle Name
                      </Typography>
                      <Controller
                        name={`middleName.${0}.value` as const}
                        control={control}
                        render={({ field, fieldState }) => (
                      <TextField
                        {...field}
                        fullWidth
                        disabled={edit && (!currentMiddleName || currentMiddleName.toLowerCase() === 'nmn')? false : true}
                        defaultValue={''}
                        placeholder="Enter your middle name"
                        error={!!fieldState.error}
                        helperText={fieldState.error?.message}
                        InputLabelProps={{shrink: true}}
                        onChange={(e) => {
                            const newValue = e.target.value;
                            field.onChange(newValue);
                            if (
                                currentMiddleName.toLowerCase() === 'nmn' &&
                                newValue.trim().toLowerCase() === 'nmn'
                            ) {
                                setTimeout(() => {
                                    setError(`middleName.${0}.value` as const, {
                                        type: 'manual',
                                        message: "You cannot re-enter 'NMN' as middle name",
                                    });
                                }, 0);
                            }
                        }}
                        InputProps={{
                          endAdornment: edit && !middleNameArray.fields[0]?.value ? (
                              <InputAdornment position="end">
                                  <Tooltip
                                      title="If you have no middle name, enter 'NMN' in the middle name field. If you have a middle name, not providing one will result in insufficient scan results."
                                      placement="top"
                                      componentsProps={{
                                          tooltip: {
                                              sx: {
                                                  fontFamily: 'InterRegular',
                                                  fontSize: '10px',
                                                  lineHeight: '16px',
                                                  fontWeight: 500,
                                                  color: '#ffffff',
                                              },
                                          },
                                      }}
                                  >
                                      <IconButton
                                          component="span"
                                          sx={{
                                              padding: 0,
                                          }}
                                      >
                                          <HelpOutlineOutlined
                                              sx={{
                                                  fontSize: '16px',
                                                  color: 'rgba(145, 53, 224, 1)',
                                              }}
                                          />
                                      </IconButton>
                                  </Tooltip>
                              </InputAdornment>
                          ) : undefined,
                        }}
                        sx={{
                          backgroundColor: '#FFF',
                          border: 'none',
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '10px',
                            height: '50px',
                            backgroundColor: '#FFF',
                            border: 'none',
                            '& fieldset': {
                              border: edit && (!currentMiddleName || currentMiddleName.toLowerCase() === 'nmn') ? '1.5px solid #9135E0 !important' : '1.5px solid #E2E8F0 !important'
                            },
                          },
                          '& .MuiInputBase-input': {
                            color: '#3A155A',
                            paddingLeft: '20px',
                            fontFamily: 'InterRegular',
                            fontWeight: 400,
                            fontSize: '14px',
                            lineHeight: '140%',
                          },
                          '& .MuiInputBase-input::placeholder': {
                              opacity: 1,
                              fontSize: '14px',
                              fontWeight: 400,
                              fontFamily: 'InterRegular',
                          },
                          '& .Mui-disabled .MuiInputBase-input::placeholder': {
                              '-webkit-text-fill-color': '#A0AEC0',
                          }
                        }}
                      />
                        )}
                      />
                    </Grid>
                  )}

                  {/* Last name */}
                  {lastNameArray.fields[0] && (
                <Grid item md={4} sm={12} sx={{width: '100%'}}>
                      <Typography
                        sx={{ ...styles.label, ...styles.required }}>
                        Last Name
                      </Typography>
                      <TextField
                        fullWidth
                        placeholder="Enter your last name"
                        disabled={edit && !lastNameArray.fields[0]?.value ? false : true}
                        error={!!errors?.lastName?.[0]?.value}
                        helperText={errors?.lastName?.[0]?.value?.message}
                        InputLabelProps={{shrink: true}}
                        defaultValue={''}
                        {...register(`lastName.${0}.value` as const)}
                        sx={{
                          backgroundColor: '#FFF',
                          border: 'none',
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '10px',
                            height: '50px',
                            backgroundColor: '#FFF',
                            border: 'none',
                            '& fieldset': {
                              border: edit && !lastNameArray.fields[0]?.value ? '1.5px solid #9135E0 !important' : '1.5px solid #E2E8F0 !important'
                            },
                          },
                          '& .MuiInputBase-input': {
                            color: '#3A155A',
                            paddingLeft: '20px',
                            fontFamily: 'InterRegular',
                            fontWeight: 400,
                            fontSize: '14px',
                            lineHeight: '140%',
                          },
                           '& .MuiInputBase-input::placeholder': {
                              opacity: 1,
                              fontSize: '14px',
                              fontWeight: 400,
                              fontFamily: 'InterRegular',
                          },
                          '& .Mui-disabled .MuiInputBase-input::placeholder': {
                              '-webkit-text-fill-color': '#A0AEC0',
                          }
                        }}
                      />
                    </Grid>
                  )}
                </Grid>
              </Stack>
              <Stack spacing={3} display={'flex'} flexDirection={['column', 'row']}>
                <Grid
                  container
                  spacing={2}
                  alignItems="flex-start"
                  sx={{ width: '100%' }}>

                  {/* Birtdate */}
                  <Grid item md={4} sm={12}>
                    <Typography sx={{ ...styles.label, ...styles.required }}>
                      Birthday  
                    </Typography>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <Controller
                        name={'birthdate'}
                        control={control}
                        rules={{
                          validate: (value) => {
                            if (!value) return true;
                            const today = new Date();
                            const birthDate = new Date(value);
                            let age = today.getFullYear() - birthDate.getFullYear();
                            const m = today.getMonth() - birthDate.getMonth();
                            if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                              age--;
                            }
                            return age >= 18 || 'You must be at least 18 years old.';
                          }
                        }}
                        render={({ field }) => (
                          <DatePicker
                            disableFuture
                            disabled={!edit || isDobDisabled}
                            components={{
                              OpenPickerIcon: CalendarIcon,
                            }}
                            onOpen={() => {
                              if (field.value) {
                                const currentDate = new Date(field.value);
                                if (!isNaN(currentDate.getTime())) {
                                  setOriginalDob(currentDate);
                                }
                              }
                            }}
                            onAccept={(newValue: any) => {
                              if (!newValue || !originalDob) {
                                return;
                              }

                              const newDate = new Date(newValue);
                              const originalDate = new Date(originalDob);

                              if (isNaN(newDate.getTime()) || isNaN(originalDate.getTime())) {
                                Toast.show({ type: 'error', text1: 'Invalid date selected. Please try again.' });
                                if (originalDob && !isNaN(new Date(originalDob).getTime())) {
                                  setValue('birthdate', originalDob, { shouldDirty: true });
                                }
                                return;
                              }

                              if (newDate.getTime() !== originalDate.getTime()) {
                                // Calculate actual time difference in years (more accurate than just year difference)
                                const timeDifferenceMs = Math.abs(newDate.getTime() - originalDate.getTime());
                                const timeDifferenceYears = timeDifferenceMs / (1000 * 60 * 60 * 24 * 365.25); // Account for leap years

                                setTimeout(() => {
                                  trigger('birthdate').then(isValid => {
                                    if (isValid) {
                                      if (timeDifferenceYears >= 1) {
                                        setNewDob(newDate);
                                        setIsDobModalOpen(true);
                                      } else {
                                        handleDirectDobUpdate(newDate);
                                      }
                                    }
                                  }).catch(validationError => {
                                    console.error('Error during date validation:', validationError);
                                    Toast.show({ type: 'error', text1: 'Date validation failed. Please check your input.' });
                                  });
                                }, 0);
                              }
                            }}
                            renderInput={(params) => (
                              <TextField
                                fullWidth
                                {...params}
                                error={!!errors?.birthdate}
                                helperText={errors?.birthdate?.message ?? ''}
                                InputProps={{
                                  ...params.InputProps,
                                }}
                                sx={{
                                  backgroundColor: '#FFF',
                                  border: 'none',
                                  borderRadius: '10px',
                                  '& .MuiOutlinedInput-root': {
                                    borderRadius: '10px',
                                    height: '50px',
                                    backgroundColor: '#FFF',
                                    border: 'none',
                                    '& fieldset': {
                                      border: edit && !isDobDisabled ? '1.5px solid #9135E0 !important' : '1.5px solid #E2E8F0 !important',
                                    },
                                  },
                                  '& .MuiInputBase-input': {
                                    color: '#3A155A',
                                    paddingLeft: '20px',
                                    fontFamily: 'InterRegular',
                                    fontWeight: 400,
                                    fontSize: '14px',
                                    lineHeight: '140%',
                                  },
                                  '& .MuiInputAdornment-root .MuiIconButton-root': {
                                    padding: 0,
                                    marginRight: 1,
                                  },
                                }}
                              />
                            )}
                            {...field}
                          />
                        )}
                      />
                    </LocalizationProvider>
                  </Grid>

                  {/* Linkedin field */}
                  <Grid item md={4} sm={12}>
                    <Typography sx={styles.label}>
                      LinkedIn URL
                    </Typography>
                    <TextField
                      fullWidth
                      disabled={!edit}
                      defaultValue={linkedInValue}
                      error={!!errors?.linkedIn}
                      helperText={errors?.linkedIn?.message}
                      InputLabelProps={{ shrink: true }}
                      {...register('linkedIn', {
                        onChange: async (e) => {
                          await handleLinkedInChange(e.target.value);
                        },
                        onBlur: async () => {
                          await trigger('linkedIn')
                        },
                      })}
                      sx={{
                        backgroundColor: '#FFF',
                        border: 'none',
                        '& .MuiOutlinedInput-root': {
                          borderRadius: '10px',
                          height: '50px',
                          backgroundColor: '#FFF',
                          border: 'none',
                          '& fieldset': {
                            border: edit ? '1.5px solid #9135E0 !important' : '1.5px solid #E2E8F0 !important'
                          },
                        },
                        '& .MuiInputBase-input': {
                          color: '#3A155A',
                          paddingLeft: '20px',
                          fontFamily: 'InterRegular',
                          fontWeight: 400,
                          fontSize: '14px',
                          lineHeight: '140%',
                        },
                      }}
                    />
                  </Grid>
                  </Grid>
              </Stack>
            </Stack>
          </Card>

          {/* Other names card */}
          <Card
            sx={{
              py: !isMobile ? 5 : 2,
              px: isMobile ? 0 : 5,
              mt: !isMobile ? 3 : 0,
              borderRadius: '15px',
              overflow: 'auto',
              boxShadow: isMobile ? 'none' : '0px 6px 10px 4px #0000000A',
            }}
          >
            <Stack width={{md: '92%', lg: '90.5%'}} spacing={3} display={'flex'} flexDirection={'column'}>
            <Typography sx={styles.header}>
              Other Names
            </Typography>
            <Stack spacing={3} display={'flex'} flexDirection={'column'}>
              <Typography sx={styles.paragraph}>
                Optional: You can include alternative names like nicknames, maiden
                names, or names from marriage changes. For example,
                &quot;Robert&quot; could be &quot;Bob&quot;. We&apos;ll use
                whatever full name you provide to conduct our search.
              </Typography>
              <Stack
                spacing={3}
                display={'flex'}
                flexDirection={['column', 'row']}>
                <Grid
                  container
                  spacing={2}
                  alignItems="center"
                  sx={{width: '100%'}}>
                <Grid item md={4} sm={12} sx={{width: '100%'}}>
                    <Typography
                      sx={styles.label}
                    >
                      First Name
                    </Typography>
                    <TextField
                      fullWidth
                      placeholder='Enter your first name'
                      disabled={edit && !otherFirstNameArray.fields[0]?.value ? false : true }
                      defaultValue={''}
                    InputLabelProps={{shrink: true}}
                      {...register(`otherFirstName.0.value` as const)}
                      error={!!errors?.otherFirstName?.[0]?.value}
                      helperText={
                        errors?.otherFirstName?.[0]?.value?.message || ''
                      }
                      sx={{
                        backgroundColor: '#FFF',
                        border: 'none',
                        '& .MuiOutlinedInput-root': {
                          borderRadius: '10px',
                          height: '50px',
                          backgroundColor: '#FFF',
                          border: 'none',
                          '& fieldset': {
                            border: edit && !otherFirstNameArray.fields[0]?.value ? '1.5px solid #9135E0 !important' : '1.5px solid #E2E8F0 !important',
                          },
                        },
                        '& .MuiInputBase-input': {
                          color: '#3A155A',
                          paddingLeft: '20px',
                          fontFamily: 'InterRegular',
                          fontWeight: 400,
                          fontSize: '14px',
                          lineHeight: '140%',
                        },
                        '& .MuiInputBase-input::placeholder': {
                            opacity: 1,
                            fontSize: '14px',
                            fontWeight: 400,
                            fontFamily: 'InterRegular',
                        },
                        '& .Mui-disabled .MuiInputBase-input::placeholder': {
                            '-webkit-text-fill-color': '#A0AEC0',
                        }
                      }}
                    />
                  </Grid>
                <Grid item md={4} sm={12} sx={{width: '100%'}}>
                    <Typography
                      sx={styles.label}
                    >
                      Maiden Name
                    </Typography>
                    <TextField
                      fullWidth
                      placeholder='Enter your maiden name'
                      defaultValue={''}
                      disabled={edit && !otherMaidenNameArray.fields[0]?.value ? false : true }
                    InputLabelProps={{shrink: true}}
                      {...register(`otherMaidenName.0.value` as const)}
                      error={!!errors?.otherMaidenName?.[0]?.value}
                      helperText={
                        errors?.otherMaidenName?.[0]?.value?.message || ''
                      }
                      sx={{
                        backgroundColor: '#FFF',
                        border: 'none',
                        '& .MuiOutlinedInput-root': {
                          borderRadius: '10px',
                          height: '50px',
                          backgroundColor: '#FFF',
                          border: 'none',
                          '& fieldset': {
                            border: edit && !otherMaidenNameArray.fields[0]?.value ? '1.5px solid #9135E0 !important' : '1.5px solid #E2E8F0 !important',
                          },
                        },
                        '& .MuiInputBase-input': {
                          color: '#3A155A',
                          paddingLeft: '20px',
                          fontFamily: 'InterRegular',
                          fontWeight: 400,
                          fontSize: '14px',
                          lineHeight: '140%',
                        },
                        '& .MuiInputBase-input::placeholder': {
                            opacity: 1,
                            fontSize: '14px',
                            fontWeight: 400,
                            fontFamily: 'InterRegular',
                        },
                        '& .Mui-disabled .MuiInputBase-input::placeholder': {
                            '-webkit-text-fill-color': '#A0AEC0',
                        }
                      }}
                    />
                  </Grid>
                </Grid>
              </Stack>
            </Stack>
            </Stack>
          </Card>
        </Stack>
      </ThemeProvider>
      {/* DOB Confirmation Dialog */}
      <Dialog
        open={isDobModalOpen}
        onClose={handleDobUpdateDisagree}
        disableEscapeKeyDown={false}
        PaperProps={{
          sx: {
            borderRadius: '16px',
            padding: '24px',
            minWidth: '480px',
            maxWidth: '520px',
            boxShadow: '0px 8px 32px rgba(0, 0, 0, 0.12)',
          }
        }}
      >
        <DialogTitle sx={{
          padding: 0,
          marginBottom: '16px',
          fontSize: '20px',
          fontWeight: 600,
          color: '#1A1B20'
        }}>
          <Box display="flex" alignItems="center" gap={2}>
            <Box
              sx={{
                width: '40px',
                height: '40px',
                borderRadius: '8px',
                backgroundColor: '#FFF3E0',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <WarningIcon sx={{ color: '#FF9800', fontSize: '24px' }} />
            </Box>
            <Typography variant="h6" sx={{ fontWeight: 600, color: '#1A1B20' }}>
              Last Chance to Update
            </Typography>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ padding: 0, marginBottom: '32px' }}>
          <Typography
            sx={{
              fontSize: '16px',
              lineHeight: '24px',
              color: '#1A1B20',
              fontWeight: 600,
              marginBottom: '16px'
            }}
          >
            This is your last chance to update your date of birth.
          </Typography>
          <Typography
            sx={{
              fontSize: '16px',
              lineHeight: '24px',
              color: '#615F6B',
              marginBottom: '12px'
            }}
          >
            Please note:
          </Typography>
          <Box component="ul" sx={{
            margin: 0,
            paddingLeft: '24px',
            '& li': {
              fontSize: '16px',
              lineHeight: '24px',
              color: '#615F6B',
              marginBottom: '8px'
            }
          }}>
            <li>Your previous scan records will be permanently deleted.</li>
            <li>New scan records will be generated after the update.</li>
          </Box>
          <Typography
            sx={{
              fontSize: '16px',
              lineHeight: '24px',
              color: '#1A1B20',
              fontWeight: 500,
              marginTop: '16px'
            }}
          >
            Do you want to continue?
          </Typography>
        </DialogContent>
        <DialogActions sx={{
          padding: 0,
          gap: '12px',
          justifyContent: 'flex-end'
        }}>
          <Button
            onClick={handleDobUpdateDisagree}
            sx={{
              minWidth: '80px',
              height: '40px',
              borderRadius: '8px',
              textTransform: 'none',
              fontSize: '14px',
              fontWeight: 500,
              color: '#FFFFFF',
              backgroundColor: '#DC2626',
              border: 'none',
              boxShadow: 'none',
              '&:hover': {
                backgroundColor: '#B91C1C',
                boxShadow: '0px 2px 8px rgba(220, 38, 38, 0.3)'
              }
            }}
          >
            No
          </Button>
          <Button
            onClick={handleDobUpdateAgree}
            variant="contained"
            sx={{
              minWidth: '80px',
              height: '40px',
              borderRadius: '8px',
              textTransform: 'none',
              fontSize: '14px',
              fontWeight: 500,
              backgroundColor: '#16A34A',
              color: '#FFFFFF',
              border: 'none',
              boxShadow: 'none',
              '&:hover': {
                backgroundColor: '#15803D',
                boxShadow: '0px 2px 8px rgba(22, 163, 74, 0.3)'
              }
            }}
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

const LocationsAddressesSection: React.FC<LocationsAddressesSectionProps> = ({
  addressArray,
  register,
  errors,
  addressValues,
  trigger,
}) => {
  const isMobile = useMediaQuery('(max-width:600px)')
  const [editableIndex, setEditableIndex] = useState(-1)

  const handleDelete = (array: FieldValues, index: number) => {
    array.remove(index)
  }
  const handleAddAddress = async () => {

    const lastAddress = addressValues[addressArray.fields.length - 1]
    const isIncomplete = isAddressIncomplete(lastAddress)
    if (isIncomplete) {
      Toast.show({
        type: 'warning',
        text1: 'Address left blank. Add a new address or delete the field to trigger a new scan.',
      })
      return
    }

    const isValid = await trigger('address');
    if (!isValid) return;

    if (addressArray.fields.length <= 6) {
      addressArray.append({
        state: '' as 'CA',
        city: '',
        streetAddress: '',
        zip: ''
      })
      setEditableIndex(addressArray.fields.length)
    } else {
      Toast.show({
        type: 'warning',
        text1: 'You can not add more than 6 secondary addresses.',
      })
    }
  }

  const isAddressComplete = useCallback((address: AddressType): boolean => {
        return Boolean(
            address.city?.trim() &&
            address.state?.trim() &&
            address.zip?.trim()
        )
    },[])

  return (
    <ThemeProvider theme={theme}>
      <Stack spacing={3}>
        <Card
            sx={{
              py: !isMobile ? 5 : 2,
              px: isMobile ? 0 : 5,
              mt: !isMobile ? 5 : 0,
              minHeight: '585px',
              borderRadius: '15px',
              overflow: 'auto',
              boxShadow: isMobile ? 'none' : '0px 6px 10px 4px #0000000A',
            }}
          >
        <Box style={styles.inputContainer}>
          {!isMobile && (
            <Typography sx={styles.header}>
              Address
            </Typography>
          )}
          <Typography sx={styles.paragraph} mb={10}>
            We use your information to look for additional records of yours.
            Additional information such as previous addresses and alternative
            names helps us find more of your data.
          </Typography>

            <Stack>
            {addressArray.fields.map((field, index) => (
              <Box key={field.id}>
                <Box
                  sx={styles.header2}>
                  {index == 0 ? (
                    <Typography 
                    sx={{
                      fontFamily: 'InterMedium',
                      fontWeight: 500, 
                      fontSize: '16px',
                      lineHeight: '27px',
                      color: '#3A155A',
                    }}>
                      Primary Address
                    </Typography>
                  ) : (
                    <Typography 
                    sx={styles.header2}>
                      Address {index + 1}
                    </Typography>
                  )}
                </Box>
                <Grid container gap={2} sx={{width: '100%'}}>

                  {/* Street Address */}
                  <Grid item md={5} xs={10} sx={{width: '100%'}}>
                    <Typography variant="h4" sx={Object.assign({}, styles.label, styles.required)} color={'#615F6B'}>
                      Street Address
                    </Typography>
                    <TextField
                      fullWidth
                      disabled={index !== editableIndex}
                      error={!!errors?.address?.[index]?.streetAddress}
                      helperText={
                        errors?.address?.[index]?.streetAddress?.message || ''
                      }
                        InputLabelProps={{shrink: true}}
                      {...register(`address.${index}.streetAddress` as const)}
                      sx={{
                        backgroundColor: '#FFF',
                        border: 'none',
                        '& .MuiOutlinedInput-root': {
                          borderRadius: '10px',
                          height: '50px',
                          backgroundColor: '#FFF',
                          border: 'none',
                          '& fieldset': {
                            border: index !== editableIndex ? '1.5px solid #E2E8F0 !important' : '1.5px solid #9135E0 !important'
                          },
                        },
                        '& .MuiInputBase-input': {
                          color: '#3A155A',
                          paddingLeft: '20px',
                          fontFamily: 'InterRegular',
                          fontWeight: 400,
                          fontSize: '14px',
                          lineHeight: '140%',
                        },
                      }}
                    />
                  </Grid>

                  {/* City */}
                  <Grid item md={3} xs={10} sx={{width: '100%'}}>
                    <Typography
                      variant="h4"
                      color={'#615F6B'}
                        sx={Object.assign({},styles.required, styles.label)}>
                      City
                    </Typography>
                    <TextField
                      required
                      fullWidth
                      disabled={index !== editableIndex}
                      error={!!errors?.address?.[index]?.city}
                      helperText={errors?.address?.[index]?.city?.message || ''}
                        InputLabelProps={{shrink: true}}
                      {...register(`address.${index}.city` as const)}
                      sx={{
                          backgroundColor: '#FFF',
                          border: 'none',
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '10px',
                            height: '50px',
                            backgroundColor: '#FFF',
                            border: 'none',
                            '& fieldset': {
                              border: index !== editableIndex ? '1.5px solid #E2E8F0 !important' : '1.5px solid #9135E0 !important'
                            },
                          },
                          '& .MuiInputBase-input': {
                            color: '#3A155A',
                            paddingLeft: '20px',
                            fontFamily: 'InterRegular',
                            fontWeight: 400,
                            fontSize: '14px',
                            lineHeight: '140%',
                          },
                        }}
                    />
                  </Grid>
                 
                  {/* State */}
                  <Grid item md={1} xs={10} sx={{width: '100%'}}>
                    <Typography
                      variant="h4"
                      color={'#615F6B'}
                        sx={Object.assign({},styles.required, styles.label)}>
                      State
                    </Typography>
                    <TextField
                      required
                      disabled={index !== editableIndex}
                      fullWidth
                      error={!!errors?.address?.[index]?.state}
                      helperText={
                        errors?.address?.[index]?.state?.message || ''
                      }
                        InputLabelProps={{shrink: true}}
                      {...register(`address.${index}.state` as const, {
                        setValueAs: (v) => v.toUpperCase(),
                      })}
                      sx={{
                        backgroundColor: '#FFF',
                        border: 'none',
                        '& .MuiOutlinedInput-root': {
                          borderRadius: '10px',
                          height: '50px',
                          backgroundColor: '#FFF',
                          border: 'none',
                          '& fieldset': {
                            border: index !== editableIndex ? '1.5px solid #E2E8F0 !important' : '1.5px solid #9135E0 !important'
                          },
                        },
                        '& .MuiInputBase-input': {
                          color: '#3A155A',
                          paddingLeft: '20px',
                          fontFamily: 'InterRegular',
                          fontWeight: 400,
                          fontSize: '14px',
                          lineHeight: '140%',
                        },
                      }}
                    />
                  </Grid>
                  
                  {/* Zip code */}
                  <Grid item md={1.5} xs={10} sx={{width: '100%'}}>
                      <Typography variant="h4" sx={Object.assign({},styles.required, styles.label)} color={'#615F6B'}>
                      Zip Code
                    </Typography>
                    <TextField
                      disabled={index !== editableIndex}
                      fullWidth
                      error={!!errors?.address?.[index]?.zip}
                      helperText={errors?.address?.[index]?.zip?.message || ''}
                        InputLabelProps={{shrink: true}}
                      {...register(`address.${index}.zip` as const)}
                      sx={{
                        backgroundColor: '#FFF',
                        border: 'none',
                        '& .MuiOutlinedInput-root': {
                          borderRadius: '10px',
                          height: '50px',
                          backgroundColor: '#FFF',
                          border: 'none',
                          '& fieldset': {
                            border: index !== editableIndex ? '1.5px solid #E2E8F0 !important' : '1.5px solid #9135E0 !important'
                          },
                        },
                        '& .MuiInputBase-input': {
                          color: '#3A155A',
                          paddingLeft: '20px',
                          fontFamily: 'InterRegular',
                          fontWeight: 400,
                          fontSize: '14px',
                          lineHeight: '140%',
                        },
                      }}
                    />
                  </Grid>

                  {/* Edit Button */}
                  <Grid
                    item
                    xs={0.5}
                    sx={{
                      width: '100%',
                      display: 'flex',
                      marginTop: '29px',
                      marginRight: isAddressComplete(addressArray.fields[index]) ? {xs:2, sm: 0} : {xs: 10, sm: 4, md: 0},
                    }}>
                    {/* Edit Icon */}
                    <Box>
                    <img
                      onClick={() => {
                        if (index === editableIndex) {
                          setEditableIndex(-1)
                        }
                            else{
                          setEditableIndex(index)
                        }
                      }}
                      src={editIcon}
                      alt="Description of the image"
                      style={{
                        cursor: 'pointer',
                        maxWidth: '40px',
                        maxHeight: '40px',
                        marginTop: '10px',
                        marginRight: isMobile? '5px':'0px'
                      }}
                    />
                    </Box>

                    {/* Delete Button */}
                    {!isAddressComplete(addressArray.fields[index]) && (
                      <Box sx={{marginTop: 2}}>
                          <img
                              src={deleteIcon}
                              alt="Delete"
                              style={{ 
                                  width: 24, 
                                  height: 24,
                                  }}
                              onClick={() => handleDelete(addressArray, index)}
                          />
                      </Box>
                      )}
                  </Grid>

                  {/* Add address button */}
                  <Grid item md={12} sm={6}>
                    {index === addressArray.fields.length - 1 && (
                      <Button
                        sx={{
                          ...styles.button,
                        }}
                        onClick={() => {
                          handleAddAddress()
                        }}>
                        <Box 
                          component="span"
                          sx={{
                              marginRight: { lg: 2, xs: 1 },
                              marginBottom: 1, 
                              fontSize: 26, 
                              fontWeight: 100
                              }}>
                                  +
                          </Box> Add Address
                      </Button>
                    )}
                  </Grid>
                </Grid>
              </Box>
            ))}
          </Stack>
        </Box>

        {/* Address table */}
        {addressArray.fields.length > 0 && (
          <Box mt={6} sx={{ maxWidth: isMobile ? 300 : 'auto', overflowX: 'auto', marginBottom: 1.5}}>
            <Grid 
                container 
                columnGap={2}
                sx={{ 
                    width: '100%',
                    pb: 1,
                    minWidth: '600px',
                    position: 'relative',
                    '&::after': {
                        content: '""',
                        position: 'absolute',
                        bottom: 0,
                        left: 0,
                        width: {xs: '100%', sm: '90%', md:'94%', lg: '93.5%'},
                        borderBottom: '1px solid #E5E5E5'
                    }
                }}
            >
                <Grid item md={4.91} xs={4}>
                    <Typography sx={styles.addressTableHeader}>Street Address</Typography>
                </Grid>
                <Grid item xs={3}>
                    <Typography sx={styles.addressTableHeader}>City</Typography>
                </Grid>
                <Grid item xs={1}>
                    <Typography sx={styles.addressTableHeader}>State</Typography>
                </Grid>
                <Grid item xs={1.5}>
                    <Typography sx={styles.addressTableHeader}>Zip Code</Typography>
                </Grid>
                <Grid item md={0.5} xs={1} sx={{padding: 0, margin: 0}}>
                </Grid>
            </Grid>

            {addressArray.fields.filter(isAddressComplete).map((field, index) => (
              <Grid 
                container 
                key={index}
                columnGap={2}
                sx={{
                    minWidth: '600px',
                    width: '100%',
                    position: 'relative',
                    isolation: 'isolate',
                    '&::after': {
                        content: '""',
                        position: 'absolute',
                        bottom: 0,
                        zIndex: -1,
                        left: 0,
                        top: 0,
                        height: '100%',
                        width: {xs: '100%', sm: '90%', md:'94%', lg: '93.5%'},
                        backgroundColor: index % 2 !== 0 ? '#F7F8FA' : '#FFF',
                        borderBottom: '1px solid #E5E5E5',
                        borderLeft: '1px solid #E5E5E5',
                        borderRight: '1px solid #E5E5E5',
                    }
                }}
              >
                <Grid item md={4.91} xs={4} sx={styles.addressTableCell}>
                    {field.streetAddress}
                </Grid>

                <Grid item xs={3} sx={{...styles.addressTableCell, borderLeft: '1px solid #E5E5E5',}}>
                  {field.city}
                </Grid>

                <Grid item xs={1} sx={{...styles.addressTableCell, borderLeft: '1px solid #E5E5E5',}}>
                  {field.state}
                </Grid>

                <Grid item xs={1.5} sx={{...styles.addressTableCell, borderLeft: '1px solid #E5E5E5',}}>
                  {field.zip}
                </Grid>

                {index !== 0 && (
                <Grid item xs={1.3} md={0.7} lg={0.5}
                  sx={{
                      borderLeft: '1px solid #E5E5E5',
                      display: 'flex', 
                      justifyContent: 'center', 
                      alignItems: 'center',
                      py: 4,
                  }}
                >
                  <img
                      src={deleteIcon}
                      alt="Delete"
                      style={{
                          cursor: 'pointer',
                          width: 24,
                          height: 24,
                      }}
                      onClick={() => handleDelete(addressArray, index)}
                  />
                </Grid>
                )}
            </Grid>
            ))}
          </Box>
        )}  
        </Card>
      </Stack>
    </ThemeProvider>
  )
}

const ContactInfoSection: React.FC<ContactInfoSectionProps> = ({
  emailArray,
  phoneNumberArray,
  phoneNumberArrayValue,
  emailArrayValue,
  control,
  register,
  trigger,
  errors,
}) => {
  const [editableIndex, setEditableIndex] = useState<{ phone: number; email: number }>({
        phone: -1,
        email: -1,
    });
  const handleDelete = (array: FieldValues, index: number) => {
    array.remove(index)
  }
  const addSecondaryNumberOrEmail = (array: FieldValues, type: string) => {
    const lastIndex = array.fields.length - 1;
    const currentValue =
      type === 'number'
        ? phoneNumberArrayValue[lastIndex].value
        : emailArrayValue[lastIndex].value;

    const isInvalidPhone = type === 'number' && !isValidPhoneNumber(currentValue);
    const isInvalidEmail = type === 'email' && (currentValue.length > 100 || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(currentValue));

    if (!currentValue || currentValue.trim() === '' || isInvalidPhone || isInvalidEmail) {
      // If empty, show toast and return
      Toast.show({
        type: 'warning',
        text1:
          type === 'email'
            ? 'Please enter a valid email before adding another.'
            : 'Please enter a valid phone number before adding another.',
      });
      return;
    }
    if (array.fields.length < 5) {
      if (array.fields.length === 0) {
        array.insert(array.fields.length, {
          value: '',
        })
        array.swap(1, 0)
      } else if (array.fields.length === 1) {
        array.insert(array.fields.length, {
          value: '',
        })
        // array.insert(0, {
        //   value: array.fields[0].value,
        // })
      } else {
        array.insert(array.fields.length, {
          value: '',
        })
      }
      if (type === 'email') {
          setEditableIndex((prev) => ({ ...prev, email: array.fields.length }))
      }
      else{
          setEditableIndex((prev) => ({ ...prev, phone: array.fields.length }))
      }
    } else {
      array.insert(array.fields.length, {
        value: '',
      })
      array.remove(5)
      setTimeout(() => {
        Toast.show({
          type: 'warning',
          text1:
            type === 'email'
              ? 'You can not add more than 4 secondary emails.'
              : 'You can not add more than 4 secondary numbers.',
        })
      }, 500)
    }
  }

   const shouldShowDeleteButton = (array: FieldValues,index: number): boolean => {
        return index !== 0 && array.fields[index].value === '';
    };

  const isMobile = useMediaQuery('(max-width:600px)')
  return (
    <Box sx={{ flexDirection: isMobile ? 'column' : 'row' }}>

      {/* Phone number card */}
      <Card
          sx={{
            py: !isMobile ? 5 : 2,
            px: isMobile ? 0 : 5,
            mt: !isMobile ? 5 : 0,
            borderRadius: '15px',
            overflow: 'auto',
            boxShadow: isMobile ? 'none' : '0px 6px 10px 4px #0000000A',
          }}
        >
      <Stack width={{md: '98%', lg: '97%'}}>
      {!isMobile && (
        <Typography sx={styles.header}>
          Phone Number
        </Typography>
      )}

      <Typography
        sx={{
            ...styles.paragraph,
            mb:5,
        }}
        >
            We use your information to look for additional records of yours.
      </Typography>

      {phoneNumberArray.fields.length ? (
        <Typography sx={{...styles.label, ...{...styles.required}}}>
          Phone Number
        </Typography>
      ) : (
        <Typography variant="h5" mb={1}></Typography>
      )}

      {phoneNumberArray.fields.length === 0 && (
        <Grid container spacing={2} alignItems="center" mt={2}>
          <Grid item md={11.2} xs={10} sx={{width: isMobile ? '100%' : 'unset'}}>
            <Controller
              control={control}
              name={`phoneNumber.${0}.value`}
              render={({ field: controllerField, fieldState }) => (
                <PhoneNumberInput
                  context="dashboard"
                  value={controllerField.value}
                  onChange={(newValue: string) => {
                    controllerField.onChange(newValue)
                    trigger(`phoneNumber.${0}.value`)
                  }}
                  error={!!fieldState.error}
                  helperText={fieldState.error?.message}
                  placeholder="Enter Number"
                  endAdornment={
                    <img
                      src={NumberEmptyIcon}
                      width={20}
                      height={20}
                      style={{ marginLeft: 6, cursor: 'pointer' }}
                    />
                  }
                />
              )}
            />
          </Grid>
          <Grid item md={3} sm={12}>
            {phoneNumberArray.fields.length == 0 && (
              <Button
                variant={'contained'}
                color={'darkPurple'}
                onClick={() =>
                  addSecondaryNumberOrEmail(phoneNumberArray, 'number')
                }
                sx={styles.button}>
                  <Box 
                    component="span"
                    sx={{
                        marginRight: { lg: 2, xs: 1 },
                        marginBottom: 1, 
                        fontSize: 26, 
                        fontWeight: 100
                        }}>
                            +
                  </Box>
                Add Number
              </Button>
            )}
          </Grid>
        </Grid>
      )}
      {phoneNumberArray.fields.map((field, index) => (
        <Grid container key={field.id} spacing={2} alignItems="center" mt={2}>
          <Grid display={'flex'} alignItems={'center'} gap={4} item md={11.2} xs={10} sx={{width: isMobile ? '100%' : 'unset'}}>
            <Controller
              control={control}
              name={`phoneNumber.${index}.value`}
              render={({ field: controllerField, fieldState }) => (
                <PhoneNumberInput
                  context="dashboard"
                  value={controllerField.value}
                  onChange={(newValue: string) => {
                    controllerField.onChange(newValue)
                    trigger(`phoneNumber.${index}.value`)
                  }}
                  disabled={index !== editableIndex.phone}
                  error={!!fieldState.error}
                  helperText={fieldState.error?.message}
                  placeholder="Enter Number"
                  endAdornment={
                    <img
                      onClick={() => controllerField.onChange('')}
                      src={NumberEmptyIcon}
                      width={20}
                      height={20}
                      style={{ marginLeft: 6, cursor: 'pointer' }}
                    />
                  }
                />
              )}
            />
          </Grid>

          {/* edit + delete button */}
          <Grid item xs={0.8}
              sx={{
                  width: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  marginTop: errors?.phoneNumber?.[index]?.value ? {sm: '4px', md: '0px'} :'5px',
                  marginBottom: errors?.phoneNumber?.[index]?.value ? {sm: '0' ,md: '14px'} :'0px',
                  marginRight: shouldShowDeleteButton(phoneNumberArray, index) ? {xs: 7, sm: 5, md: 0} : 0,
              }}
              >
              {/* Edit Icon */}
              <Box 
                  marginRight={{xs: 0, md: 2}}
                  mt={{xs: 1, md:1.5}}
                  mb={{md: '2px'}}
                  >
                  <img
                      onClick={() => {
                          if (index === editableIndex.phone) {
                              setEditableIndex(prev => ({...prev, phone: -1}))
                          } else {
                              setEditableIndex(prev => ({...prev, phone: index}))
                          }
                      }}
                      src={editIcon}
                      alt="Description of the image"
                      style={{
                          cursor: 'pointer',
                          maxWidth: '40px',
                          maxHeight: '40px',
                      }}
                  />
              </Box>
              {/* Delete Button */}
              {shouldShowDeleteButton(phoneNumberArray, index) && (
              <Box>
                  <img
                      src={deleteIcon}
                      alt="Delete"
                      style={{ 
                          width: 22, 
                          height: 22,
                          }}
                      onClick={() => handleDelete(phoneNumberArray, index)}
                  />
              </Box>
          )}
          </Grid>

          <Grid item md={12} sm={6}>
            {index === phoneNumberArray.fields.length - 1 && (
              <Button
                variant={'contained'}
                color={'darkPurple'}
                onClick={() =>
                  addSecondaryNumberOrEmail(phoneNumberArray, 'number')
                }
                sx={styles.button}>
                <Box 
                  component="span"
                  sx={{
                      marginRight: { lg: 2, xs: 1 },
                      marginBottom: 1, 
                      fontSize: 26, 
                      fontWeight: 100
                      }}>
                          +
                </Box>
                Add Number
              </Button>
            )}
          </Grid>
        </Grid>
      ))}
      {/* Table for phone numbers */}
      {phoneNumberArray.fields.length > 0 && (
        <Box mt={6} sx={{ maxWidth: isMobile ? 310 : 'auto', overflowX: 'auto', marginBottom: 1.5}}>
          {phoneNumberArray.fields.filter((field) => field.value).map((field, index) => (
            <Grid 
              container 
              key={field.id}
              alignItems="center"
              sx={{
                  width: {xs: '95%', sm: '90%', md: '97%'},  
                  py: 2,
                  position: 'relative',
                  isolation: 'isolate',
                  backgroundColor: index % 2 !== 0 ? '#F7F8FA' : '#FFF',
                  borderBottom: '1px solid #E5E5E5',
                  borderLeft: '1px solid #E5E5E5',
                  borderRight: '1px solid #E5E5E5',
                  borderTop: index === 0 ? '1px solid #E5E5E5' : 'none',
              }}
              >
              <Grid item xs={10} sx={{ 
                p: 2, 
                display: 'flex', 
                alignItems: 'center',
                fontFamily: 'InterRegular',
                fontSize: '16px',
                color: '#6B7280',
              }}>
                {field.value}
              </Grid>

              {index !== 0 && (
              <Grid item xs={2} sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', pr: 2, }}>
                <Box component="span" sx={{ display: 'flex', alignItems: 'center' }}>
                  <img
                    src={deleteIcon}
                    alt="Delete"
                    style={{ 
                        width: 24, 
                        height: 24,
                    }}
                    onClick={() => handleDelete(phoneNumberArray, index)}
                  />
                </Box>
              </Grid>
              )}
            </Grid>
            ))}
        </Box>
      )}
      </Stack>
      </Card>

      {/* Email card */}
       <Card
          sx={{
            py: !isMobile ? 5 : 2,
            px: isMobile ? 0 : 5,
            mt: !isMobile ? 5 : 0,
            borderRadius: '15px',
            overflow: 'auto',
            boxShadow: isMobile ? 'none' : '0px 6px 10px 4px #0000000A',
          }}
        >
      <Stack width={{md: '98%', lg: '97%'}}>
      <Typography sx={styles.header}>
        Email
      </Typography>

      <Typography
        sx={{
            ...styles.paragraph,
            mb:5,
        }}
        >
            We use your information to look for additional records of yours.
      </Typography>
      {emailArray.fields.length ? (
        <Typography style={styles.header2}>
          PRIMARY EMAIL
        </Typography>
      ) : (
        <Typography variant="h5" mb={1}></Typography>
      )}
      {/* {emailArray.fields.length===1 && (
          <Grid container spacing={2} alignItems="center" mt={2}>
            <Grid item md={6} sm={12} sx={{ width: isMobile ? '100%' : 'unset' }}>
              <TextField
                sx={{ width: '100%', background: '#fff' }}
                placeholder="Enter Email..."
                disabled={true}
                error={!!errors?.email?.[0]?.value} helperText={errors?.email?.[0]?.value?.message || ''}
                value={emailArray.fields[0].value}
              />
            </Grid>
          </Grid>
        )} */}
      {emailArray.fields.length === 0 && (
        <Grid container spacing={2} alignItems="center" mt={2}>
          <Grid item md={11.2} xs={10} sx={{width: isMobile ? '100%' : 'unset'}}>
            <TextField
              fullWidth
              sx={{
                backgroundColor: '#FFF',
                border: 'none',
                '& .MuiOutlinedInput-root': {
                  borderRadius: '10px',
                  height: '50px',
                  backgroundColor: '#FFF',
                  border: 'none',
                  '& fieldset': {
                    border: emailArray.fields[0]?.value ? '1.5px solid #E2E8F0 !important' : '1.5px solid #9135E0 !important'
                  },
                },
                '& .MuiInputBase-input': {
                  color: '#3A155A',
                  fontFamily: 'InterRegular',
                  fontWeight: 400,
                  fontSize: '14px',
                  lineHeight: '140%',
                },
              }}
              placeholder="Enter Email..."
              error={!!errors?.email?.[0]?.value}
              helperText={errors?.email?.[0]?.value?.message || ''}
              {...register(`email.${0}.value` as const, {
                setValueAs: (value) => value.trim(),
              })}
              InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                        <img
                        src={EmailEmptyIcon}
                        width={20}
                        height={20}
                        style={{ marginLeft: 6, cursor: 'pointer' }}
                        />
                    </InputAdornment>
                ),
                }}
            />
          </Grid>
          <Grid item md={12} sm={12}>
            {emailArray.fields.length === 0 && (
              <Button
                variant={'contained'}
                color={'darkPurple'}
                onClick={() => addSecondaryNumberOrEmail(emailArray, 'email')}
                sx={styles.button}
                >
                <Box 
                  component="span"
                  sx={{
                      marginRight: { lg: 2, xs: 1 },
                      marginBottom: 1, 
                      fontSize: 26, 
                      fontWeight: 100
                      }}>
                          +
                </Box>
                Add Email
              </Button>
            )}
          </Grid>
        </Grid>
      )}
      {emailArray.fields.map((field, index) => (
        <>
        {(index==1) && (
        <Typography style={styles.header2} mt={5}>
          OTHER EMAILS
        </Typography>
      )}
        <Grid container spacing={2} key={field.id} alignItems="center" mt={2}>
          <Grid 
            item 
            display={'flex'} 
            alignItems={'center'} 
            gap={4} 
            md={11.2} 
            xs={10} 
            sx={{width: isMobile ? '100%' : 'unset'}}
          >
              <TextField
                fullWidth
                sx={{
                  backgroundColor: '#FFF',
                  border: 'none',
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '10px',
                    height: '50px',
                    backgroundColor: '#FFF',
                    border: 'none',
                    '& fieldset': {
                      border: index !== editableIndex.email ? '1.5px solid #E2E8F0 !important' : '1.5px solid #9135E0 !important'
                    },
                  },
                  '& .MuiInputBase-input': {
                    color: '#3A155A',
                    fontFamily: 'InterRegular',
                    fontWeight: 400,
                    fontSize: '14px',
                    lineHeight: '140%',
                  },
                  '& .MuiInputBase-input::placeholder': {
                    color: '#A0AEC0',
                    opacity: 1,
                    fontSize: '14px',
                    fontWeight: 400,
                    fontFamily: 'InterRegular',
                  },
                }}
                placeholder="Enter Email..."
                // disabled={index===0 && emailArray.fields.length > 1}
                disabled={index !== editableIndex.email}
                error={!!errors?.email?.[index]?.value}
                helperText={errors?.email?.[index]?.value?.message || ''}
                {...register(`email.${index}.value` as const, {
                  setValueAs: (value) => value.trim(),
                })}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                        <img
                        src={EmailEmptyIcon}
                        width={20}
                        height={20}
                        style={{ marginLeft: 6, cursor: 'pointer' }}
                        />
                    </InputAdornment>
                ),
                }}
              />
          </Grid>

          {/* edit + delete button */}
          <Grid item xs={0.8}
              sx={{
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                marginTop: {xs: '6px', sm: '4px', md: '5px'},
                marginBottom: errors?.email?.[index]?.value ? {sm: '0', md: '19px'} :'0px',
                marginRight: shouldShowDeleteButton(emailArray, index) ? {xs: 7, sm: 5, md: 0} : 0,
              }}
              >
              {/* Edit Icon */}
              { index !== 0 && (
              <Box 
                  marginRight={{xs: 0, md: 2}}
                  mt={{xs: 1, md:1.5}}
                  mb={{md: '2px'}}
                >
                <img
                    onClick={() => {
                        if (index == editableIndex.email) {
                            setEditableIndex(prev => ({...prev, email: -1}))
                        } else {
                            setEditableIndex(prev => ({...prev, email: index}))
                        }
                    }}
                    src={editIcon}
                    alt="Description of the image"
                    style={{
                        cursor: 'pointer',
                        maxWidth: '40px',
                        maxHeight: '40px',
                    }}
                />
              </Box>
              )}
              {/* Delete Button */}
              {shouldShowDeleteButton(emailArray, index) && (
              <Box>
                  <img
                      src={deleteIcon}
                      alt="Delete"
                      style={{ 
                          width: 22, 
                          height: 22,
                          }}
                      onClick={() => handleDelete(emailArray, index)}
                  />
              </Box>
          )}
          </Grid>
              
          <Grid item md={12} sm={6}>
            {index === emailArray.fields.length - 1 && (
              <Button
                variant={'contained'}
                color={'darkPurple'}
                onClick={() => addSecondaryNumberOrEmail(emailArray, 'email')}
                sx={{
                  ...styles.button,
                  minWidth: '136px',
                }}
                >
                <Box 
                  component="span"
                  sx={{
                      marginRight: { lg: 2, xs: 1 },
                      marginBottom: 1, 
                      fontSize: 26, 
                      fontWeight: 100
                      }}>
                          +
                </Box>
                Add Email
              </Button>
            )}
          </Grid>
        </Grid>
        </>
      ))}

      {/* Email list table */}
      {emailArray.fields.length > 0 && (
      <Box mt={6} sx={{ maxWidth: isMobile ? 310 : 'auto', overflowX: 'auto', marginBottom: 1.5 }}>
        {emailArray.fields.filter((field) => field.value).map((field, index) => (
        <Grid 
          container 
          key={field.id}
          alignItems="center"
          sx={{
              width: {xs: '95%', sm: '90%', md: '97%'},  
              py: 2,
              position: 'relative',
              isolation: 'isolate',
              backgroundColor: index % 2 !== 0 ? '#F7F8FA' : '#FFF',
              borderBottom: '1px solid #E5E5E5',
              borderLeft: '1px solid #E5E5E5',
              borderRight: '1px solid #E5E5E5',
              borderTop: index === 0 ? '1px solid #E5E5E5' : 'none',
          }}
        >
          <Grid item xs={10} sx={{ 
            p: 2, 
            display: 'flex', 
            alignItems: 'center',
            fontFamily: 'InterRegular',
            fontSize: '16px',
            color: '#6B7280',
           }}>
              {field.value}
            </Grid>

            {index !== 0 && (
            <Grid item xs={2} sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', pr: 2}}>
              <Box component="span" sx={{ display: 'flex', alignItems: 'center' }}>
                <img
                  src={deleteIcon}
                  alt="Delete"
                  style={{ 
                      width: 24, 
                      height: 24,
                  }}
                  onClick={() => handleDelete(emailArray, index)}
                />
              </Box>
            </Grid>
            )}
        </Grid>
        ))}
      </Box>
      )}
      </Stack>
      </Card>
    </Box>
  )
}

export const ExecutiveUserProfileDashboard = ({ isModalOpen, muid, setIsModalOpen }: ProfileDashboardProps) => {
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const dispatch = useAppDispatch()
  const [fetchedForMuid, setFetchedForMuid] = useState<string | null>(null)
  const [profile, setProfile] = useState<ProfileSchemaType | null>(null)
  const location = useLocation()
  const initialSection = location.state?.index || 0
  const [currentSection, setCurrentSection] = useState(initialSection)
  const [openSections, setOpenSections] = useState<number[]>(initialSection !== 0 ? [initialSection] : [])
  const [isFormChanged, setIsFormChanged] = useState(false)
    const [storeOriginalValues,setStoreOriginalValues] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const defaultModalStyle = {
    position: 'absolute' as const,
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    boxShadow: 10,
    borderRadius: 5,
    py: 2.5,
    maxHeight: '80vh',
    overflowY: 'auto',
    width: '95%',
  }

    const handleModalClose=()=>{
    setStoreOriginalValues(false)
    originalValuesRef.current = {
      addressArray: '',
      otherFirstNameArray: '',
      otherMaidenNameArray: '',
      middleNameArray: '',
      emailArray: '',
      phoneNumberArray: '',
      linkedIn: '',
      checkChanged: false
    }
    setIsModalOpen(false)
    reset()
    setFetchedForMuid(null)
    setIsLoading(true)
  }

  const {
    firstNameArray,
    lastNameArray,
    middleNameArray,
    otherFirstNameArray,
    otherMaidenNameArray,
    addressArray,
    emailArray,
    phoneNumberArray,
    register,
    errors,
    control,
    watch,
    setValue,
    handleSubmit,
    submitHandler,
    trigger,
    reset,
    setError,
  } = useProfileForm({
    linkedinOptional: true,
    streetOptional: false,
    agreeToTermsOptional: false,
    muid,
    handleClose: handleModalClose
  })


  useEffect(() => {
    if (isModalOpen && muid && fetchedForMuid!=muid) {
      (async () => {
        try {
          setFetchedForMuid(muid)
          setIsLoading(true)
          const response = await dispatch(FetchExecutiveEmployeeProfile(muid))
          //@ts-ignore
          setProfile(response.payload)
          const formData = fromProfileFields(response.payload)
          reset(formData)
        } catch (error) {
          console.error(`Failed to fetch profile for MUID ${muid}`, error)
          setProfile(null)
          reset(emptyProfileSchema())
        }
        finally{
          setIsLoading(false)
          setStoreOriginalValues(true)
        }
      })()
    }

    if (!isModalOpen) {
      reset(emptyProfileSchema())
    }
  }, [isModalOpen, muid, reset, dispatch, fetchedForMuid, setStoreOriginalValues, setIsLoading])


  const sections = ['Basic Info', 'Address', 'Phone & Email']
  const handleSectionChangeWeb = (sectionIndex: number) => {
    setCurrentSection(sectionIndex)
    if (!openSections.includes(sectionIndex)) {
            setOpenSections([...openSections, sectionIndex])
    }
  }
  const handleSectionChange = (sectionIndex: number) => {
    setOpenSections((prevOpenSections) => {
      const isOpen = prevOpenSections.includes(sectionIndex)
      if(!isOpen){
        setCurrentSection(sectionIndex)
        return [...prevOpenSections, sectionIndex]
      }
      else {
        return prevOpenSections.filter((item) => item !== sectionIndex)
      }
    })
  }

  const originalValuesRef = useRef({
    addressArray: '',
    otherFirstNameArray: '',
    otherMaidenNameArray: '',
    middleNameArray: '',
    emailArray: '',
    phoneNumberArray: '',
    linkedIn: '',
    checkChanged: false
  });

  const addressArrayValue = watch('address');
  const otherFirstNameArrayValue = watch('otherFirstName');
  const otherMaidenNameArrayValue = watch('otherMaidenName');
  const middleNameArrayValue = watch('middleName');
  const emailArrayValue = watch('email');
  const linkedIn = watch('linkedIn');
  const phoneNumberArrayValue = watch('phoneNumber');

  useEffect(() => {
    if(storeOriginalValues){
    if (originalValuesRef.current.addressArray === "" && addressArray.fields.length >=1) {
      originalValuesRef.current.addressArray = JSON.stringify(addressArray.fields.map(({ id:_, ...rest }) => rest));

        if (originalValuesRef.current.otherFirstNameArray === "" && otherFirstNameArray) {
        originalValuesRef.current.otherFirstNameArray = JSON.stringify(otherFirstNameArray.fields.map(({ id:_, ...rest }) => rest));
        }

        if (originalValuesRef.current.otherMaidenNameArray === "" && otherMaidenNameArray) {
        originalValuesRef.current.otherMaidenNameArray = JSON.stringify(otherMaidenNameArray.fields.map(({ id:_, ...rest }) => rest));
        }

        if (originalValuesRef.current.emailArray === "" && emailArray) {
        originalValuesRef.current.emailArray = JSON.stringify(emailArray.fields.map(({ id:_, ...rest }) => rest));
        }
        if (originalValuesRef.current.middleNameArray === "" && middleNameArray) {
                originalValuesRef.current.middleNameArray = JSON.stringify(middleNameArray.fields.map(({
                    id: _,
                    ...rest
                }) => rest));
            }
        if (originalValuesRef.current.phoneNumberArray === "" && phoneNumberArray) {
        if(phoneNumberArray.fields.length === 0){
          originalValuesRef.current.phoneNumberArray = JSON.stringify([{"value":""}]);
          }
        else{
          originalValuesRef.current.phoneNumberArray = JSON.stringify(phoneNumberArray.fields.map(({ id:_, ...rest }) => rest));
          }
        }

      if (originalValuesRef.current.linkedIn === "") {
          originalValuesRef.current.linkedIn = linkedIn || "";
      }
      originalValuesRef.current.checkChanged = true;
    }}

    const hasNumberChanged = () =>{
      if(phoneNumberArrayValue.length === 0){
        return false;
      }
      else{
        return JSON.stringify(phoneNumberArrayValue) !== originalValuesRef.current.phoneNumberArray &&
        phoneNumberArrayValue.every((value:any)=> value.value != "");
      }
    }

    const hasFormChanged = () =>{
      if(JSON.stringify(addressArrayValue) !== originalValuesRef.current.addressArray && addressArrayValue.every((value:any)=>value.city !="")){
        return true
      }
      if(JSON.stringify(otherFirstNameArrayValue) !== originalValuesRef.current.otherFirstNameArray ||
        JSON.stringify(otherMaidenNameArrayValue) !== originalValuesRef.current.otherMaidenNameArray ||
        JSON.stringify(middleNameArrayValue) !== originalValuesRef.current.middleNameArray) {
        return true
      }
      if(JSON.stringify(emailArrayValue) !== originalValuesRef.current.emailArray && emailArrayValue.every((value:any)=> value.value!="")){
        return true
      }
      if ((linkedIn) !== originalValuesRef.current.linkedIn) {
          return true;
      }
      if(hasNumberChanged()){
        return true
      }
      return false
    }

    if(originalValuesRef.current.checkChanged){
      setIsFormChanged(hasFormChanged())
    }


  }, [addressArray, addressArrayValue, emailArray, emailArrayValue, otherFirstNameArray, linkedIn,
    otherFirstNameArrayValue, otherMaidenNameArray, otherMaidenNameArrayValue, middleNameArray, middleNameArrayValue, phoneNumberArray, phoneNumberArrayValue, storeOriginalValues]);

  const isMiddleNameValid = () => {
        return errors.middleName?.[0]?.value?.message === "You cannot re-enter 'NMN' as middle name";
    };
  
  const handleFormSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    if (!isFormChanged) {
      // Show a message when no changes are detected
      Toast.show({
        type: 'warning',
        text1: 'Add or update your information to run a new scan',
      })
      return
    }

    if (isMiddleNameValid()) {
            Toast.show({
                type: 'error',
                text1: "You cannot re-enter 'NMN' as middle name",
            })
            return
    }

    // If the form has changes, proceed with normal submission
    handleSubmit(submitHandler)(e)
  }

  const getBody = () => {
    return (
      <Container sx={defaultModalStyle} >
        <Container sx={{width: '98%', marginX: 0}}>
        <Container sx={{display: 'flex', width: '100%', justifyContent:'space-between', alignItems:'center'}}>
          <Typography variant="h2">
            User Profile Management
          </Typography>
          <IconButton
            edge="end"
            color="inherit"
            onClick={handleModalClose}
            sx={{
              zIndex: 1,
              position: 'relative',
              left: isMobile ? 8 : 20,
              bottom: isMobile ? 5 : 0,
              paddingX: 0,
              color: '#ffffff',
            }}>
				<img src={closeicon} style={{width: '42px'}}/>
          </IconButton>
        </Container>
        {isMobile ? (
          <Stack
            spacing={0}
            component={'form'}
            onSubmit={handleFormSubmit}
            flexDirection={'column'}>
          <Card sx={{position: 'relative', boxShadow: 'none'}}>
              {sections.map((section, index) => (
                <React.Fragment key={index}>
                  <ListItem disablePadding>
                    <ListItemButton
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                      }}
                      onClick={() => handleSectionChange(index)}>
                        <Typography variant="body1" sx={{color: '#1A1B20'}}>
                        {section}
                      </Typography>
                      {openSections.includes(index) ? (
                          <ExpandLess/>
                      ) : (
                          <ExpandMore/>
                      )}
                    </ListItemButton>
                  </ListItem>
                  <Collapse
                    in={openSections.includes(index)}
                    timeout="auto"
                    unmountOnExit>
                    <List component="div" disablePadding>
                      <ListItem
                        disablePadding
                        sx={{
                          width: 'calc(100% - 30px)',
                          marginLeft: 2,
                          marginRight: 2,
                          p: 2,
                        }}>
                        {
                          isLoading &&
                            <div style={{height:'100%', width:'100%', display: 'flex', justifyContent: 'center', alignItems:'center'}}>
                                <CircularProgress color = 'info'></CircularProgress>
                          </div>
                        }
                        {!isLoading && index === 0 && profile && (
                          <PersonalInfoSection
                            watch={watch}
                            setValue={setValue}
                            firstNameArray={firstNameArray}
                            middleNameArray={middleNameArray}
                            lastNameArray={lastNameArray}
                            otherFirstNameArray={otherFirstNameArray}
                            otherMaidenNameArray={otherMaidenNameArray}
                            register={register}
                            errors={errors}
                            control={control}
                            trigger={trigger}
                            muid={muid}
                            profile={profile}
                            setProfile={setProfile}
                            setError={setError}
                          />
                        )}
                        {!isLoading && index === 1 && (
                          <LocationsAddressesSection
                            addressArray={addressArray}
                            register={register}
                            errors={errors}
                            control={control}
                            addressValues={addressArrayValue}
                            trigger={trigger}
                          />
                        )}
                        {!isLoading && index === 2 && (
                          <ContactInfoSection
                            setValue={setValue}
                            emailArray={emailArray}
                            phoneNumberArray={phoneNumberArray}
                            phoneNumberArrayValue={phoneNumberArrayValue}
                            emailArrayValue={emailArrayValue}
                            register={register}
                            trigger={trigger}
                            errors={errors}
                            control={control}
                          />
                        )}
                      </ListItem>
                    </List>
                  </Collapse>
                </React.Fragment>
              ))}
            <Typography variant="body2" sx={{mt: 5, pb: 3, my: 1, mx: 2}}>
              <Box sx={{display: 'flex', alignItems: 'center'}}>
                <ShieldIcon style={{ width: 50, height: 50, marginRight: 4 }} />
                  <Box>
                      <Typography
                        variant="body2"
                        component="span"
                        sx={{
                        color: '#6B7280',
                        fontWeight: 400,
                        fontFamily: 'InterRegular',
                        fontSize: '12px',
                        }}
                      >
                        mePrism uses industry-standard encryption to protect
                        confidentiality of all information you provide.
                      </Typography>
                      <Typography
                          variant="body2"
                          component="span"
                          sx={{
                          color: '#9135E0 !important',
                          fontFamily: 'InterMedium',
                          fontWeight: 600,
                          fontSize: '12px',
                          ml: 0.5,
                          }}
                      >
                        We do not sell your data.
                      </Typography>
                  </Box>
              </Box>
              </Typography>
              <Box sx={{display: "flex", justifyContent: 'center', mb: 2}}>
                <Button
                  type={'submit'}
                  onClick={handleFormSubmit}
                  sx={{
                  ...styles.button,
                  maxWidth: '250px',
                  mx:2, my: 1,
                  }}>
                Save & Run New Scan
                </Button>
              </Box>
            </Card>
          </Stack>
        ) : (
          <PageLayout>
            <Stack
              component={'form'}
              onSubmit={handleFormSubmit}>
              <Grid container sx={{ margin: 5, }}>
                <Grid
                  item
                  md={12}
                  xs={12}
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                  }}>
                  <Grid item sm={7}>
                    <Sidebar
                      activeSection={currentSection}
                      sections={sections}
                      onSectionChange={handleSectionChangeWeb}
                    />
                  </Grid>
                  <Grid item sm={5} sx={{ ...styles.inputContainer, display: 'flex', justifyContent: 'flex-end' }}>
                    <Button
                      variant={'contained'}
                      onClick={handleFormSubmit}
                      type={'submit'}
                      sx={{
                        border: '2px solid #9135E0',
                        background: '#9135E0',
                        width: '100%',
                        maxWidth: '250px',
                        fontSize: '12px',
                        height: '60px',
                        p: 1.5,
                        color: '#fff', '&.Mui-disabled': {
                          background: 'white',
                          color: '#A0A0A4',
                          border: '2px solid #A0A0A4',
                          opacity: 0.7,
                        },
                        ':hover': {
                          background: '#9135E0',
                          color: '#fff',
                        }
                      }}>
                      Save & Run New Scan
                    </Button>
                  </Grid>
                </Grid>
                <Grid item md={12} xs={12}>
                  {' '}
                  <Box sx={{ position: 'relative', minHeight: '90%' }}>
                    {
                      isLoading &&
                        <div style={{position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)'}}>
                            <CircularProgress color="info"/>
                      </div>
                    }
                    {!isLoading && currentSection === 0 && profile && (
                      <PersonalInfoSection
                        watch={watch}
                        setValue={setValue}
                        firstNameArray={firstNameArray}
                        middleNameArray={middleNameArray}
                        lastNameArray={lastNameArray}
                        otherFirstNameArray={otherFirstNameArray}
                        otherMaidenNameArray={otherMaidenNameArray}
                        register={register}
                        errors={errors}
                        control={control}
                        trigger={trigger}
                        muid={muid}
                        profile={profile}
                        setProfile={setProfile}
                        setError={setError}
                      />
                    )}
                    {!isLoading && currentSection === 1 && (
                      <LocationsAddressesSection
                        addressArray={addressArray}
                        register={register}
                        errors={errors}
                        control={control}
                        addressValues={addressArrayValue}
                        trigger={trigger}
                      />
                    )}

                    {!isLoading && currentSection === 2 && (
                      <ContactInfoSection
                        setValue={setValue}
                        emailArray={emailArray}
                        phoneNumberArray={phoneNumberArray}
                        phoneNumberArrayValue={phoneNumberArrayValue}
                        emailArrayValue={emailArrayValue}
                        register={register}
                        trigger={trigger}
                        errors={errors}
                        control={control}
                      />
                    )}
                    {!isLoading &&
                      <Typography
                        variant="body2"
                        sx={{position: 'relative', bottom: 0, mt: 4,}}>
                        <Box sx={{display: 'flex', alignItems: 'center'}}>
                          <ShieldIcon style={{ width: 24, height: 24, marginRight: 8 }} />
                          <Box>
                              <Typography
                                variant="body2"
                                component="span"
                                sx={{
                                color: '#6B7280',
                                fontWeight: 400,
                                fontFamily: 'InterRegular',
                                fontSize: '12px',
                                }}
                              >
                                mePrism uses industry-standard encryption to protect
                                confidentiality of all information you provide.
                              </Typography>
                              <Typography
                                  variant="body2"
                                  component="span"
                                  sx={{
                                  color: '#9135E0 !important',
                                  fontFamily: 'InterMedium',
                                  fontWeight: 600,
                                  fontSize: '12px',
                                  ml: 0.5,
                                  }}
                              >
                                We do not sell your data.
                              </Typography>
                          </Box>
                        </Box>
                      </Typography>}
                  </Box>
                </Grid>
              </Grid>
            </Stack>
          </PageLayout>
        )}
      </Container>
      </Container>
    )
  }


  return (
    <Modal
      open={isModalOpen}
      onClose={handleModalClose}
      sx={{ backdropFilter: 'blur(5px)' }}
    >
      {getBody()}
    </Modal>
  )
}
